import React from 'react';
import gruveLogo from '../../assets/gruve-logo.png';

const GruveLogo = ({ size = 'w-12 h-12', className = '' }) => {
  return (
    <img
      src={gruveLogo}
      alt="Gruve"
      className={`${size} ${className} object-contain`}
    />
  );
};

export default GruveLogo;
